<script lang="ts" setup>
import { reactive } from 'vue';

import KpModal from '@kp/geofy-vuejs-lib/tg-system/components/KpModal.vue';

const emit = defineEmits(['login', 'cancel']);

const model = reactive({
    username: '',
    password: ''
});

const show = defineModel({ default: false });

defineProps<{
    loading?: boolean;
    error?: string | null;
}>();

function onLogin() {
    emit('login', { username: model.username, password: model.password });
}
</script>
<template>
    <KpModal v-model="show">
        <h2 class="ktg-modal-title">{{ $t('login') }}</h2>
        <form @submit.prevent="onLogin">
            <ktg-field>
                <ktg-label for="username">{{ $t('username') }}</ktg-label>

                <ktg-text-input
                    v-model="model.username"
                    input-id="username"
                    type="text"
                    autofocus
                    placeholder="z.b. 'hans.muster'"
                    required
                >
                </ktg-text-input>
            </ktg-field>

            <ktg-field>
                <ktg-label for="password">{{ $t('pw') }}</ktg-label>

                <ktg-text-input v-model="model.password" input-id="password" type="password" required> </ktg-text-input>
            </ktg-field>

            <ktg-clues v-if="error">
                <ktg-clue>
                    <ktg-clue-title icon="info">{{ $t('error') }}</ktg-clue-title>
                    <ktg-clue-text>{{ error }}</ktg-clue-text>
                </ktg-clue>
            </ktg-clues>
            <ktg-modal-buttons>
                <ktg-button
                    class="cancel-button"
                    appearance="secondary"
                    size="small"
                    :disabled="loading"
                    @click="$emit('cancel')"
                >
                    {{ $t('cancel') }}
                </ktg-button>

                <ktg-button class="confirm-button" size="small" :disabled="loading" type="submit">
                    {{ $t('login') }}
                </ktg-button>
            </ktg-modal-buttons>
        </form>
    </KpModal>
</template>
